import React, { useState, useContext, useEffect } from "react";
import FuncionesContext, {
  getAtributo,
} from "../../../context/FuncionesContext";
import { Switch, styled } from "@mui/material";

const CustomSwitch = styled(Switch)(({ theme }) => ({
  "& .MuiSwitch-switchBase.Mui-checked.Mui-disabled": {
    color: "hsl(231, 48.4%, 70%)",
  },
  "& .MuiSwitch-switchBase.Mui-checked.Mui-disabled + .MuiSwitch-track": {
    backgroundColor: "hsl(231, 48.4%, 47.8%)",
  },
  "& .MuiSwitch-track": {
    opacity: 0.5,
  },
}));

const Toggle = ({ data, cab, campokey, id_elemento, updateState, opElegida }) => {
  const { superSubmit } = useContext(FuncionesContext);

  const [value, setValue] = useState(data[campokey]);
  const [lastValue, setLastvalue] = useState(data[campokey]);
  const [update_id, setUpdate_id] = useState(data[cab.update_id_alias]);

  const usarValores = cab.usar_valores?.split(",") ?? [];

  let s = usarValores[0]?.toString().trim() ?? "s";
  let n = usarValores[1]?.toString().trim() ?? "n";

  const handleCancelar = () => {
    setValue(lastValue);
  };

  const handleChange = async (e) => {
    const valor = e.target.checked ? s : n;

    const { id_a } = cab;

    setValue(valor);

    superSubmit({ valor, id_a, update_id, handleCancelar, cab, data, opElegida })
      .then((result) => {
        setLastvalue(() => valor);

        updateState(campokey, valor);

        if (result.data.eliminado) {
          updateState(cab.update_id_alias, null);
          setUpdate_id(null);
        } else if (!update_id) {
          updateState(cab.update_id_alias, result.data.registro.id);
          setUpdate_id(result.data.registro.id);
        }

        return result;
      })
      .catch((err) => {
        console.log("Cancelado ", err);
      });
  };

  useEffect(() => {
    const updateInertalAttributes = () => {
      setValue(data[campokey]);
      setUpdate_id(data[cab.update_id_alias]);
    };

    document.addEventListener(cab.id_a, updateInertalAttributes);

    return document.removeEventListener(cab.id_a, updateInertalAttributes);
  }, [cab.id_a, cab.update_id_alias, campokey, data]);

  const disabled = getAtributo("disabled", data, cab);

  return (
    <div
      id={id_elemento}
      className="tarjeta_grid_item_label_item"
      style={{ justifyContent: "center" }}
    >
      <CustomSwitch
        disabled={disabled === "s"}
        color="primary"
        className="list-toggle"
        checked={
          value === null ? false : value?.toString() === s ? true : false
        }
        onChange={handleChange}
      />
    </div>
  );
};

export default Toggle;
